module.exports = "import React from 'react';\nimport { TextArea } from '@patternfly/react-core';\n\nclass SimpleTextArea extends React.Component {\n  state = {\n    value: ''\n  };\n\n  handleTextAreaChange = value => {\n    this.setState({ value });\n  };\n\n  render() {\n    const { value } = this.state;\n\n    return <TextArea value={value} onChange={this.handleTextAreaChange} aria-label=\"text area example\" />;\n  }\n}\n\nexport default SimpleTextArea;\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/raw-loader!../react-core/src/components/TextArea/examples/SimpleTextArea.js
// module id = 443
// module chunks = 84336607365395 114276838955818